var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    { staticClass: "text-character-wrapper" },
    [
      _vm._m(0),
      _vm._v(" "),
      _c("div", { staticClass: "row" }, [
        _c(
          "div",
          { staticClass: "col-4" },
          [
            _c(_setup.CInput, {
              staticClass: "flex-fill",
              attrs: {
                label: "Width",
                step: 1,
                type: "decimal",
                disabled: true,
                "fraction-digits": 2,
              },
              model: {
                value: _setup.model.fileWidth,
                callback: function ($$v) {
                  _vm.$set(_setup.model, "fileWidth", $$v)
                },
                expression: "model.fileWidth",
              },
            }),
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "col-4" },
          [
            _c(_setup.CInput, {
              staticClass: "flex-fill",
              attrs: {
                label: "Height",
                step: 1,
                type: "decimal",
                disabled: true,
                "fraction-digits": 2,
              },
              model: {
                value: _setup.model.fileHeight,
                callback: function ($$v) {
                  _vm.$set(_setup.model, "fileHeight", $$v)
                },
                expression: "model.fileHeight",
              },
            }),
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "col-4" },
          [
            _c(_setup.CInput, {
              staticClass: "flex-fill",
              attrs: { label: "Unit", type: "text", disabled: true },
              model: {
                value: _setup.model.unit,
                callback: function ($$v) {
                  _vm.$set(_setup.model, "unit", $$v)
                },
                expression: "model.unit",
              },
            }),
          ],
          1
        ),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "row" }, [
        _c(
          "div",
          { staticClass: "col-5" },
          [
            _c(_setup.CInput, {
              staticClass: "flex-fill",
              attrs: { label: "Export Format", type: "text", disabled: true },
              model: {
                value: _setup.model.format,
                callback: function ($$v) {
                  _vm.$set(_setup.model, "format", $$v)
                },
                expression: "model.format",
              },
            }),
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "col-7" },
          [
            _c(_setup.CInput, {
              staticClass: "flex-fill",
              attrs: {
                label: "Export Resolution",
                type: "text",
                disabled: true,
              },
              model: {
                value: _setup.model.dpi,
                callback: function ($$v) {
                  _vm.$set(_setup.model, "dpi", $$v)
                },
                expression: "model.dpi",
              },
            }),
          ],
          1
        ),
      ]),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "row",
          staticStyle: { "padding-top": "10px", "padding-bottom": "15px" },
        },
        [
          _c(
            "div",
            { staticClass: "col-12" },
            [
              _c(_setup.CButton, {
                staticStyle: { width: "100%" },
                attrs: {
                  variant: "outline-primary",
                  text: "Edit Production File",
                },
                on: { click: _setup.editProductionFile },
              }),
            ],
            1
          ),
        ]
      ),
      _vm._v(" "),
      _vm._m(1),
      _vm._v(" "),
      _vm._l(_setup.model.variants, function (variant, index) {
        return _c("div", { key: index, staticClass: "row" }, [
          _c(
            "div",
            { staticClass: "col-12" },
            [
              _c(_setup.CSelect, {
                attrs: {
                  options: variant.values.map((v, i) => ({
                    label: v,
                    value: v,
                    object: { position: i + 1 },
                  })),
                  label: variant.name,
                },
                on: {
                  input: (option) =>
                    _setup.selectVariant(variant.isColorVariant, option),
                },
                model: {
                  value: variant.selected,
                  callback: function ($$v) {
                    _vm.$set(variant, "selected", $$v)
                  },
                  expression: "variant.selected",
                },
              }),
            ],
            1
          ),
        ])
      }),
      _vm._v(" "),
      _setup.hasColorVariant
        ? _c(
            "div",
            { staticClass: "row", staticStyle: { "padding-top": "10px" } },
            [
              _c(
                "div",
                { staticClass: "col-12" },
                [
                  _c(_setup.CButton, {
                    staticStyle: { width: "100%" },
                    attrs: {
                      variant: "outline-primary",
                      text: "Generate Color Images",
                    },
                    on: { click: _setup.generateColorImages },
                  }),
                ],
                1
              ),
            ]
          )
        : _vm._e(),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "row", staticStyle: { "padding-top": "10px" } },
        [
          _c(
            "div",
            { staticClass: "col-12" },
            [
              _c(_setup.CButton, {
                staticStyle: { width: "100%" },
                attrs: { variant: "outline-primary", text: "Edit Preview" },
                on: { click: _setup.editPreview },
              }),
            ],
            1
          ),
        ]
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "row", staticStyle: { "padding-top": "20px" } },
        [
          _c(
            "div",
            { staticClass: "col-12" },
            [
              _c(_setup.CButton, {
                staticStyle: { width: "100%" },
                attrs: { variant: "primary", text: "Save" },
                on: { click: _setup.save },
              }),
            ],
            1
          ),
        ]
      ),
    ],
    2
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c,
      _setup = _vm._self._setupProxy
    return _c("div", { staticClass: "row" }, [
      _c("div", { staticClass: "col-12" }, [
        _c("label", { staticClass: "text-strong" }, [
          _vm._v("Production File"),
        ]),
      ]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c,
      _setup = _vm._self._setupProxy
    return _c("div", { staticClass: "row" }, [
      _c("div", { staticClass: "col-12" }, [
        _c("label", { staticClass: "text-strong" }, [
          _vm._v("Preview & Variants"),
        ]),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }